import { render, staticRenderFns } from "./SupplierOrder.vue?vue&type=template&id=1e6c7250&scoped=true"
import script from "./SupplierOrder.vue?vue&type=script&lang=js"
export * from "./SupplierOrder.vue?vue&type=script&lang=js"
import style0 from "./SupplierOrder.vue?vue&type=style&index=0&id=1e6c7250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6c7250",
  null
  
)

export default component.exports